import { render } from "./catalogEdit.vue?vue&type=template&id=ad1d6f64&scoped=true"
import script from "./catalogEdit.vue?vue&type=script&lang=js"
export * from "./catalogEdit.vue?vue&type=script&lang=js"

import "./catalogEdit.vue?vue&type=style&index=0&id=ad1d6f64&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad1d6f64"]])

export default __exports__